import {MeetingRepository} from "../api/repositories/MeetingRepository";
import {DateTime} from "luxon";
import Vue from 'vue';
import {Store} from "vuex";
import { Busyness } from "../api/models/meetings/Busyness";

export class ParticipantBusynessHelper {
    meetingRepository: MeetingRepository;
    userId: number;
    list: any[] = [];
    backend = '';
    store: Store<any>;

    constructor(meetingRepository: MeetingRepository, backend: string, store: Store<any>) {
        this.meetingRepository = meetingRepository;
        this.backend = backend;
        this.store = store;
    }

    async setUserId(userId: number) {
        this.userId = userId;
        try {
            await this.fetchList();
        }
        catch (e) {
            this.store.dispatch('reportException', e, {root: true});
        }
    }

    private async fetchList() {
        const list = (await this.meetingRepository.busyness(DateTime.local(), [this.userId], process.env.VUE_APP_AGENDA_SCHEMA!) || [])
            .map((item: Busyness) => {
                const type = item.type == 'session' ? 'event' : 'meeting',
                      participantsKey = type == 'event' ? 'speakers' : 'participants';
                return {
                    title: item.title || '',
                    start: item.beginAt.toISO({ includeOffset: false }),
                    end: item.endAt.toISO({ includeOffset: false }),
                    [participantsKey]:  item.participants || [],
                    elementType: item.type,
                    type: type,
                    backend: this.backend,
                    isBusyness: true
                }
            })
        Vue.set(this, 'list', list);
    }
}